import styled from 'styled-components';

export const TableWrapperContainer = styled.div.attrs({})`
  width: 100%;
  background: ${(props) =>
    props.background
      ? props.theme.palette.colors.background
      : props.theme.palette.colors.white};
  padding: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
`;

export const TableWrapperHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

export const TableWrapperButtonContainer = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const TableHeaderTitleContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px; /* Espaço entre os Cards e o Pesquisar */
  margin-left: auto; /* Força o agrupamento para a direita */
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    margin-left: 0;
  }
`;

export const TableHeaderSubTitle = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  margin-top: 16px;
  color: ${(props) => props.theme.palette.colors.black};
`;

export const ContainerOutlined = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  width: 300px;
  margin-left: 50px;
  @media (max-width: 450px) {
    width: 100%;
    min-width: 200px;
  }
`;

export const Link = styled.span.attrs({})`
  font-family: Kumbh Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  text-decoration-line: underline;
  text-decoration-style: solid;
  cursor: pointer;
`;

export const ButtonContent = styled.div.attrs({})`
  width: fit-content;
  @media (max-width: 450px) {
    width: 100%;
  }
`;
